module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "blank"
  }, [_c('div', {
    staticClass: "about-top"
  }, [_c('div', {
    staticClass: "about-icon"
  }), _vm._v(" "), _c('p', {
    staticClass: "za-title"
  }, [_vm._v("点点")]), _vm._v(" "), _c('p', {
    staticClass: "za-info"
  }, [_vm._v("v1.0.0")]), _vm._v(" "), _c('group', [_c('cell', {
    attrs: {
      "title": "关于点点"
    },
    on: {
      "click": function($event) {
        return _vm.nextRoute('aboutdetail')
      }
    }
  }, [_c('div', {
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("../assets/images/link.png"),
      "height": "12",
      "width": "7",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "客服电话"
    },
    on: {
      "click": function($event) {
        return _vm.tel()
      }
    }
  }, [_c('div', {
    staticClass: "about-right",
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }, [_c('p', [_vm._v("1010-9955")]), _vm._v(" "), _c('p', [_vm._v("工作日：09:00-18:00")])])])], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "about-bottom"
  }, [_vm._v(" Copyright © 点点")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fb1c3bfc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/aboutus.vue
// module id = 218
// module chunks = 0